export default __webpack_public_path__ + "static/media/opsgenie.6b2f5e5a.svg";